import { get } from '../../../utils/object-helpers';

const multipliers = {
    DAYS: 86400000,
    HOURS: 3600000,
    MINUTES: 60000,
    SECONDS: 1000
};

export default class {
    onCreate(input) {
        this.timer = null;
        this.startTime = new Date(get(input, 'counterStartTime.value', 0)).getTime();
        this.urgencyTime = new Date(get(input, 'urgencyTime.value', 0)).getTime();
        this.endTime = new Date(get(input, 'endTime.value', 0)).getTime();
        this.labelTemplate = get(input, 'label.template', '');
        this.daysTemplate = get(input, 'days.template', '');
        this.hoursTemplate = get(input, 'hours.template', '');
        this.minutesTemplate = get(input, 'minutes.template', '');
        this.secondsTemplate = get(input, 'seconds.template', '');
        this.state = {};
    }

    onMount() {
        this.refreshState();
    }

    refreshState() {
        const now = new Date().getTime();
        const started = now >= this.startTime;
        const expired = now >= this.endTime;
        if (started && !expired) {
            const urgency = now >= this.urgencyTime;
            this.state = {
                active: true,
                urgency,
                displayLabel: this.calculateLabel(now, urgency)
            };
        } else {
            this.state = {
                expired
            };
        }
        this.checkIntervalState(expired);
    }

    checkIntervalState(expired) {
        if (expired && this.timer) {
            clearInterval(this.timer);
        } else if (!expired && !this.timer) {
            this.timer = setInterval(this.refreshState.bind(this), 1000);
        }
    }

    calculateLabel(now, urgency) {
        const timeLeft = this.endTime - now;
        const days = Math.floor(timeLeft / multipliers.DAYS);
        const hours = Math.floor((timeLeft % multipliers.DAYS) / multipliers.HOURS);
        const minutes = Math.floor((timeLeft % multipliers.HOURS) / multipliers.MINUTES);
        const seconds = Math.floor((timeLeft % multipliers.MINUTES) / multipliers.SECONDS);
        let label = '';
        if (days > 0) {
            label += `${this.daysTemplate.replace('{dd}', days)} `;
        }
        if (hours > 0) {
            label += `${this.hoursTemplate.replace('{hh}', hours)} `;
        }
        if (days === 0 || urgency) {
            label += `${this.minutesTemplate.replace('{mm}', minutes)} `;
        }
        if (urgency) {
            label += `${this.secondsTemplate.replace('{ss}', seconds)} `;
        }
        return this.labelTemplate.replace('{x}', label.trim());
    }
}
